import React from 'react';

interface Props {
  content: GeneratedRichContent;
}

export const ProposalAIRichContent: React.FC<Props> = ({ content }) => (
  <div className="proposal-ai-generator__rich-content">
    {content.paragraphs.map((paragraph, index) => (
      <p key={`${paragraph}-${index}`} className="t-text-2">
        {paragraph}
      </p>
    ))}

    {!!content.bullets.length && (
      <ul className="proposal-ai-generator__bullet-list t-text-2">
        {content.bullets.map((bullet, index) => (
          <li key={`${bullet}-${index}`}>{bullet}</li>
        ))}
      </ul>
    )}
  </div>
);
